import { ReactText } from 'react'

export const formatValue = (result: ReactText | string, precision = 13) => {
	if (result?.toString().match(/\./)) {
		return String(result).substr(0, String(result).indexOf('.') + precision)
	} else {
		return result
	}
}
